if (!customElements.get('oidara-product')) {
 customElements.define('oidara-product', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.addEventListener('click', (event) => {
    const button = event.target.closest('[data-media-target]');
    if (button) this.showMedia(button.dataset.mediaTarget);
   });
   this.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="id"]')) return;
    const variant = event.target;
    this.querySelector('[data-price]').textContent = variant.dataset.price;
    const compare = this.querySelector('[data-compare]');
    compare.textContent = variant.dataset.compare || '';
    compare.hidden = !variant.dataset.compare;
    const button = this.querySelector('[data-add]');
    button.disabled = variant.dataset.available !== 'true';
    const config = JSON.parse(this.querySelector('[data-product-config]').textContent);
    button.querySelector('[data-add-label]').textContent = button.disabled ? 'Agotado' : config.buttonLabel;
    const rule = config.variants.find(item => String(item.id) === variant.value);
    const quantity = this.querySelector('[name="quantity"]');
    if (rule && quantity) { quantity.min = rule.min; quantity.step = rule.step; quantity.value = rule.min; if (rule.max != null) quantity.max = rule.max; else quantity.removeAttribute('max'); }
    if (variant.dataset.media) this.showMedia(variant.dataset.media);
    if (this.dataset.productPage === 'true') { const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); window.history.replaceState({}, '', url); }
   });
  }
  showMedia(id) {
   if (!Array.from(this.querySelectorAll('[data-media-id]')).some(panel => panel.dataset.mediaId === id)) return;
   this.querySelectorAll('[data-media-id]').forEach(panel => { panel.hidden = panel.dataset.mediaId !== id; if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
   this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
  }
 });
}
